import type { CatEntryPage, Channel } from "@/api_client";
import { CatEntryForm } from "@/components/products/cat/entry/CatEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type CatEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function CatEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<CatEntryProps>) {
  const {
    isLoading,
    isSubmitting,
    submitEntryHandler,
    policyHolder,
    user,
    content,
  } = useEntryForWebComponents<CatEntryPage>({
    productType: "cat",
    backendHost,
    appPathPrefix,
    skipCart,
    channel,
    contentPageKey: "catEntryPage",
    language,
  });

  if (isLoading) return <ProductContainer.Loader />;

  return (
    <CatEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
